import React from 'react';
import { Card, CardContent } from '../ui/card';

function DescriptionWithLinks({ description }: { description: string }) {
  const linkRegex = /https?:\/\/[^\s]+/g;
  const tokens: Array<string | React.JSX.Element> = [];
  let lastIndex = 0;

  // Assign once before we start
  let match = linkRegex.exec(description);

  while (match !== null) {
    // Push text before the URL
    if (match.index > lastIndex) {
      tokens.push(description.slice(lastIndex, match.index));
    }

    // Push the URL as a clickable link
    tokens.push(
      <a
        key={`${match[0]}-${match.index}`}
        href={match[0]}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-500 underline"
      >
        {match[0]}
      </a>
    );

    lastIndex = linkRegex.lastIndex;
    // Reassign at the end of the loop
    match = linkRegex.exec(description);
  }

  // Push whatever’s left after the last URL
  if (lastIndex < description.length) {
    tokens.push(description.slice(lastIndex));
  }

  return (
    <Card>
      <CardContent className="pt-6">
        <p className="whitespace-pre-wrap">{tokens}</p>
      </CardContent>
    </Card>
  );
}

export default DescriptionWithLinks;
